import paths from "./paths";
import components from "./components";
import description from "./description";
import config from "../config/config.local";

export default {
  openapi: "3.0.0",
  info: {
    title: "Sizeid business api",
    description,
    contact: {
      name: "Contact",
      url: "https://sizeid.com/cs/contact",
    },
    version: "1.0.0"
  },

  servers: [...config.apis],
  paths,
  components,
  security: [{ client: [] }]
};
